export default class BlockBanner {
	static init() {

		let banner = document.querySelector('.banner');
		if(!banner) {
			return;
		}

		const swiperText = banner.querySelector('.banner-home .swiper-text');
		if (!swiperText) {
			return;
		}

		let optionsSwiperText = {
			autoplay: {
				delay: 3000,
			},
			speed: 800,
			slidesPerView: "1",
			loop: true,
			allowTouchMove: true,
			pagination: {
				el: ".swiper-pagination",
			},
		};

		let swiperTexts = new Swiper(swiperText, optionsSwiperText);

		const swiperPicto = banner.querySelector('.banner-home .swiper-picto');
		if (!swiperPicto) {
			return;
		}

		let optionsSwiperPicto = {
			direction: "vertical",
			speed: 800,
			slidesPerView: "1",
			loop: true,
			allowTouchMove: false,
		};

		let swiperPictos = new Swiper(swiperPicto, optionsSwiperPicto);

		swiperPictos.controller.control = [swiperTexts];
		swiperTexts.controller.control = [swiperPictos];
	}
}
